import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import type { FC } from 'react'
import { useQueryClient } from 'react-query'
import TeamMemberEditScreen from './TeamMemberEditScreen'

export const TeamMemberEditScreenRedirect: FC = () => {
  const { hasRota } = useHomeType()

  const queryClient = useQueryClient()

  const flags = useFeatureFlags({
    flagNames: [
      'team_member',
      'rostering_change_management',
      'group_access_management',
      'roles_and_permissions'
    ]
  })?.data

  const teamMemberEnabled = flags?.team_member?.enabled
  const flagsRosteringChangeManagement =
    flags?.rostering_change_management?.enabled

  const groupAccessManagementEnabled = flags?.group_access_management?.enabled

  const rolesAndPermissionsEnabled = flags?.roles_and_permissions?.enabled

  return (
    <TeamMemberEditScreen
      teamMemberEnabled={teamMemberEnabled}
      hasRota={hasRota}
      flagsRosteringChangeManagement={flagsRosteringChangeManagement}
      queryClient={queryClient}
      groupAccessManagementEnabled={groupAccessManagementEnabled}
      rolesAndPermissionsEnabled={rolesAndPermissionsEnabled}
    />
  )
}
